var _classCallCheck = require("/Users/abdulihshan/Projects/ishro-web-react-v3/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/abdulihshan/Projects/ishro-web-react-v3/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/Users/abdulihshan/Projects/ishro-web-react-v3/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/abdulihshan/Projects/ishro-web-react-v3/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/abdulihshan/Projects/ishro-web-react-v3/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

(function () {
  "use strict";

  var e = {
    411: function _(e, t, o) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.Context = void 0;
      var r = o(297).createContext({
        siteKeyV2: "",
        siteKeyV3: "",
        loaded: !1
      });
      t.Context = r;
    },
    644: function _(e, t, o) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.ReCaptchaProvider = void 0;
      var r = o(297),
          n = o(411);

      var a = /*#__PURE__*/function (_r$Component) {
        _inherits(a, _r$Component);

        var _super = _createSuper(a);

        function a(e) {
          var _this;

          _classCallCheck(this, a);

          _this = _super.call(this, e), _this.state = {
            loaded: !1
          }, _this.onLoadHandler = _this.onLoadHandler.bind(_assertThisInitialized(_this));
          return _this;
        }

        _createClass(a, [{
          key: "componentDidMount",
          value: function componentDidMount() {
            var _this$props = this.props,
                _this$props$siteKeyV = _this$props.siteKeyV3,
                e = _this$props$siteKeyV === void 0 ? "explicit" : _this$props$siteKeyV,
                _this$props$langCode = _this$props.langCode,
                t = _this$props$langCode === void 0 ? "" : _this$props$langCode,
                _this$props$hideV3Bad = _this$props.hideV3Badge,
                o = _this$props$hideV3Bad === void 0 ? !1 : _this$props$hideV3Bad,
                r = "react-recaptcha-v3-v2-script";

            if (null === document.querySelector("script[data-id=\"".concat(r, "\"]"))) {
              window.GoogleReCaptcha_onload = this.onLoadHandler;

              var _o = document.createElement("script");

              _o.setAttribute("data-id", r), _o.setAttribute("src", "https://www.google.com/recaptcha/api.js?render=".concat(e, "&onload=GoogleReCaptcha_onload&hl=").concat(t)), _o.setAttribute("async", "true"), _o.setAttribute("defer", "true"), document.body.appendChild(_o);
            } else window.GoogleReCaptcha_onload ? window.GoogleReCaptcha_onload = this.onLoadHandler : this.setState({
              loaded: !0
            });

            var n = "react-recaptcha-v3-v2-style";

            if (o && null === document.querySelector("style[data-id=\"".concat(n, "\"]"))) {
              var _e = document.createElement("style");

              _e.innerHTML = ".grecaptcha-badge{display: none;}", _e.setAttribute("data-id", n), document.body.appendChild(_e);
            }
          }
        }, {
          key: "componentWillUnmount",
          value: function componentWillUnmount() {
            window.GoogleReCaptcha_onload && (window.GoogleReCaptcha_onload = function () {
              delete window.GoogleReCaptcha_onload;
            });
          }
        }, {
          key: "render",
          value: function render() {
            var _this$props2 = this.props,
                e = _this$props2.children,
                t = _this$props2.siteKeyV3,
                o = _this$props2.siteKeyV2,
                _a = this.state.loaded,
                i = {
              siteKeyV2: o,
              siteKeyV3: t,
              loaded: _a
            };
            return r.createElement(n.Context.Provider, {
              value: i
            }, e);
          }
        }, {
          key: "onLoadHandler",
          value: function onLoadHandler() {
            delete window.GoogleReCaptcha_onload, this.setState({
              loaded: !0
            });
          }
        }]);

        return a;
      }(r.Component);

      t.ReCaptchaProvider = a;
    },
    432: function _(e, t, o) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.withContext = void 0;
      var r = o(297),
          n = o(411);

      t.withContext = function (e) {
        return /*#__PURE__*/function (_r$Component2) {
          _inherits(_class, _r$Component2);

          var _super2 = _createSuper(_class);

          function _class() {
            _classCallCheck(this, _class);

            return _super2.apply(this, arguments);
          }

          _createClass(_class, [{
            key: "render",
            value: function render() {
              return r.createElement(n.Context.Consumer, null, function (e, t) {
                return function (o) {
                  return r.createElement(e, Object.assign({}, t, {
                    providerContext: o
                  }));
                };
              }(e, this.props));
            }
          }]);

          return _class;
        }(r.Component);
      };
    },
    160: function _(e, t) {
      var o;
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.ESize = void 0, function (e) {
        e.Normal = "normal", e.Compact = "compact";
      }(o || (o = {})), t.ESize = o;
    },
    362: function _(e, t) {
      var o;
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.ETheme = void 0, function (e) {
        e.Light = "light", e.Dark = "dark";
      }(o || (o = {})), t.ETheme = o;
    },
    276: function _(e, t, o) {
      var r = this && this.__rest || function (e, t) {
        var o = {};

        for (var r in e) {
          Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (o[r] = e[r]);
        }

        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var n = 0;

          for (r = Object.getOwnPropertySymbols(e); n < r.length; n++) {
            t.indexOf(r[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[n]) && (o[r[n]] = e[r[n]]);
          }
        }

        return o;
      };

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.ReCaptchaV2 = void 0;
      var n = o(297),
          a = o(160),
          i = o(362);

      var s = /*#__PURE__*/function (_n$Component) {
        _inherits(s, _n$Component);

        var _super3 = _createSuper(s);

        function s(e) {
          var _this2;

          _classCallCheck(this, s);

          _this2 = _super3.call(this, e);
          var t = _this2.props.providerContext.siteKeyV2;
          if (!t) throw new Error('The prop "siteKeyV2" must be set on the ReCaptchaProvider before using the ReCaptchaV2 component');
          _this2.state = {
            ref: n.createRef(),
            widgetId: void 0,
            token: void 0,
            expired: !1,
            error: !1
          }, _this2.successCallback = _this2.successCallback.bind(_assertThisInitialized(_this2)), _this2.expiredCallback = _this2.expiredCallback.bind(_assertThisInitialized(_this2)), _this2.errorCallback = _this2.errorCallback.bind(_assertThisInitialized(_this2)), _this2.shouldRenderWidget = _this2.shouldRenderWidget.bind(_assertThisInitialized(_this2));
          return _this2;
        }

        _createClass(s, [{
          key: "componentDidUpdate",
          value: function componentDidUpdate() {
            this.shouldRenderWidget(this.state.ref, this.props);
          }
        }, {
          key: "componentDidMount",
          value: function componentDidMount() {
            this.shouldRenderWidget(this.state.ref, this.props);
          }
        }, {
          key: "shouldRenderWidget",
          value: function shouldRenderWidget(e, t) {
            var _t$providerContext = t.providerContext,
                o = _t$providerContext.loaded,
                r = _t$providerContext.siteKeyV2,
                n = t.theme,
                a = t.size,
                i = t.tabindex,
                _s = this.state.widgetId;
            void 0 === _s && o && e.current && r && this.setState({
              expired: !1,
              error: !1,
              widgetId: grecaptcha.render(e.current, {
                sitekey: r,
                callback: this.successCallback,
                "expired-callback": this.expiredCallback,
                "error-callback": this.errorCallback,
                theme: n,
                size: a,
                tabindex: i
              })
            });
          }
        }, {
          key: "render",
          value: function render() {
            var e = this.state.ref,
                t = this.props,
                o = t.theme,
                a = t.callback,
                i = t.size,
                _s2 = t.tabindex,
                c = t.providerContext,
                d = r(t, ["theme", "callback", "size", "tabindex", "providerContext"]);
            return n.createElement("div", Object.assign({
              ref: e
            }, d));
          }
        }, {
          key: "successCallback",
          value: function successCallback(e) {
            var t = this.props.callback;
            this.setState({
              token: e,
              expired: !1,
              error: !1
            }, function () {
              t(e);
            });
          }
        }, {
          key: "expiredCallback",
          value: function expiredCallback() {
            var e = this.props.callback;
            this.setState({
              expired: !0
            }, function () {
              e(!1);
            });
          }
        }, {
          key: "errorCallback",
          value: function errorCallback() {
            var e = this.props.callback;
            this.setState({
              error: !0
            }, function () {
              e(new Error());
            });
          }
        }]);

        return s;
      }(n.Component);

      t.ReCaptchaV2 = s, s.defaultProps = {
        theme: i.ETheme.Light,
        size: a.ESize.Normal,
        tabindex: 0
      };
    },
    327: function _(e, t, o) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.ReCaptchaV2 = void 0;
      var r = o(432),
          n = o(276),
          a = r.withContext(n.ReCaptchaV2);
      t.ReCaptchaV2 = a;
    },
    831: function _(e, t, o) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.ReCaptchaV3 = void 0;
      var r = o(297);

      var n = /*#__PURE__*/function (_r$Component3) {
        _inherits(n, _r$Component3);

        var _super4 = _createSuper(n);

        function n(e) {
          var _this3;

          _classCallCheck(this, n);

          _this3 = _super4.call(this, e), _this3.unMounting = !1;
          var t = _this3.props.providerContext.siteKeyV3;
          if (!t) throw new Error('The prop "siteKeyV3" must be set on the ReCaptchaProvider before using the ReCaptchaV3 component');
          _this3.state = {
            token: void 0,
            retrieving: !1
          }, _this3.getToken = _this3.getToken.bind(_assertThisInitialized(_this3));
          return _this3;
        }

        _createClass(n, [{
          key: "componentDidMount",
          value: function componentDidMount() {
            this.getToken();
          }
        }, {
          key: "componentDidUpdate",
          value: function componentDidUpdate(e) {
            var t = this.props.providerContext.loaded;
            e.providerContext.loaded !== t && t && this.getToken();
          }
        }, {
          key: "render",
          value: function render() {
            return !1;
          }
        }, {
          key: "componentWillUnmount",
          value: function componentWillUnmount() {
            this.unMounting = !0;
          }
        }, {
          key: "getToken",
          value: function getToken() {
            var _this4 = this;

            var _this$props$providerC = this.props.providerContext,
                e = _this$props$providerC.loaded,
                t = _this$props$providerC.siteKeyV3,
                o = this.state.retrieving,
                _this$props3 = this.props,
                r = _this$props3.action,
                _n = _this$props3.callback;
            e && !o && t && this.setState({
              token: void 0,
              retrieving: !0
            }, function () {
              _n(), grecaptcha.execute(t, {
                action: r
              }).then(function (e) {
                _this4.unMounting || _this4.setState({
                  token: e,
                  retrieving: !1
                }, function () {
                  _n(e, _this4.getToken);
                });
              });
            });
          }
        }]);

        return n;
      }(r.Component);

      t.ReCaptchaV3 = n;
    },
    24: function _(e, t, o) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.ReCaptchaV3 = void 0;
      var r = o(432),
          n = o(831),
          a = r.withContext(n.ReCaptchaV3);
      t.ReCaptchaV3 = a;
    },
    297: function _(e) {
      e.exports = require("react");
    }
  },
      t = {};

  function o(r) {
    var n = t[r];
    if (void 0 !== n) return n.exports;
    var a = t[r] = {
      exports: {}
    };
    return e[r].call(a.exports, a, a.exports, o), a.exports;
  }

  var r = {};
  (function () {
    var e = r;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.ReCaptchaV3 = e.ReCaptchaV2 = e.ReCaptchaProvider = e.EReCaptchaV2Size = e.EReCaptchaV2Theme = void 0;
    var t = o(644);
    Object.defineProperty(e, "ReCaptchaProvider", {
      enumerable: !0,
      get: function get() {
        return t.ReCaptchaProvider;
      }
    });
    var n = o(160);
    Object.defineProperty(e, "EReCaptchaV2Size", {
      enumerable: !0,
      get: function get() {
        return n.ESize;
      }
    });
    var a = o(362);
    Object.defineProperty(e, "EReCaptchaV2Theme", {
      enumerable: !0,
      get: function get() {
        return a.ETheme;
      }
    });
    var i = o(327);
    Object.defineProperty(e, "ReCaptchaV2", {
      enumerable: !0,
      get: function get() {
        return i.ReCaptchaV2;
      }
    });
    var s = o(24);
    Object.defineProperty(e, "ReCaptchaV3", {
      enumerable: !0,
      get: function get() {
        return s.ReCaptchaV3;
      }
    });
  })(), module.exports = r;
})();